import React from 'react';
import PropTypes from 'prop-types';

import { Icon, Tooltip, Loader } from '@weezevent/nacre';
import Styles from '../../../styles/minisite/blocks.module.css';
import { Trans, useTranslation } from 'react-i18next';
import HTMLReactParser from 'html-react-parser';

export default function DescriptionBlock({ block, event = {}, onClick }) {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = React.useState(false);

    let ctaText = t('ticket.event.minisite.block.description-edit');

    const handleClick = React.useCallback(() => {
        setIsLoading(true);
        onClick();
    }, [onClick]);

    if (!block) {
        return (
            <div className={`${Styles['create-content']} ${isLoading ? Styles['disabled-create-content'] : ''}`} onClick={handleClick}>
                {isLoading && <Loader inline />}
                <Icon name="edit" />
                <Trans i18nKey="ticket.event.minisite.block.add-block-description" />
            </div>
        );
    }

    let renderData = HTMLReactParser(block.data);
    if (!block.data.trim().length) {
        renderData = (
            <div className={Styles['description-content']}>
                <Icon name="edit" />
                <Trans i18nKey="ticket.event.minisite.block.description" />
            </div>
        );
    }

    return (
        <div className={`${Styles['block-description']}`}>
            <span className={Styles['block-editable-delete']}>
                <Tooltip title={t('ticket.event.minisite.description')} position="top" triggerOnHover mini>
                    <span
                        className={Styles['block-editable-cta']}
                        onClick={() => {
                            window.location = `${window.weezConfig.temporary.menhirUrl}/bo/configuration_identite.php?id_evenement=${event.id}`;
                        }}
                    >
                        <Icon size="small" name="edit" /> {ctaText}
                    </span>
                </Tooltip>
            </span>
            {renderData}
        </div>
    );
}

DescriptionBlock.propTypes = {
    event: PropTypes.object
};
